import { render } from "./RouterForwardView.vue?vue&type=template&id=51fd22ce"
import script from "./RouterForwardView.vue?vue&type=script&lang=js"
export * from "./RouterForwardView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__